document.addEventListener("DOMContentLoaded", function () {
  const img = document.querySelector(".via-image-magnify-hover");

  if (!img) return;

  const lens = document.createElement("div");
  lens.classList.add("zoom-lens");
  img.parentElement.style.position = "relative";
  img.parentElement.appendChild(lens);

  const zoomSize = 150; // lens size
  lens.style.width = zoomSize + "px";
  lens.style.height = zoomSize + "px";

  function moveLens(e) {
    e.preventDefault();
    const pos = getCursorPos(e, img);
    let x = pos.x - zoomSize / 2;
    let y = pos.y - zoomSize / 2;

    if (x > img.width - zoomSize) x = img.width - zoomSize;
    if (x < 0) x = 0;
    if (y > img.height - zoomSize) y = img.height - zoomSize;
    if (y < 0) y = 0;

    lens.style.left = x + "px";
    lens.style.top = y + "px";
    lens.style.backgroundPosition = `-${x * 2}px -${y * 2}px`;
  }

  function getCursorPos(e, element) {
    const rect = element.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    return { x: x, y: y };
  }

  lens.style.backgroundImage = `url(${img.src})`;
  lens.style.backgroundRepeat = "no-repeat";
  lens.style.backgroundSize = img.width * 2 + "px " + img.height * 2 + "px";

  img.addEventListener("mousemove", moveLens);
  lens.addEventListener("mousemove", moveLens);

  img.addEventListener("mouseenter", () => lens.style.display = "block");
  img.addEventListener("mouseleave", () => lens.style.display = "none");

  lens.style.display = "none";
});
